var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{staticClass:"px-4 py-2",attrs:{"cols":"12"}},[_c('TabelaAnexos')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }